import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion';
import axiosInstance from '../../utils/axios/axiosConfig';
import { toast } from 'react-toastify';
import { Loading } from '../../components';
import { DeleteModal } from '../../components';
import { useAccessChecker } from '../../utils/Functions/Authorization';
import { Download, Search, CirclePlus, ImageIcon, CornerDownRight, Trash2, ChevronDown, Pencil } from 'lucide-react'
import ReviewModal from './ReviewModal';

function Reviews() {

    const { checkAccess } = useAccessChecker();

    const [reviewModal, setReviewModal] = useState(false)
    const [ReviewId, setReviewId] = useState(null)

    const [reviews, setReviews] = useState([])
    const [reviewToUpdate, setReviewToUpdate] = useState(null)

    const [searchValue, setSearchValue] = useState(null)

    const [loading, setLoding] = useState(false)
    const [done, setDone] = useState(false)
    const [deleteModal, setDeleteModal] = useState(false)



    useEffect(() => {
        getReview()
    }, [ReviewId, done, searchValue])




    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const getReview = async (page = 1) => {
        try {
            setLoding(true);
            const response = await axiosInstance.post(`/reviews/search?page=${page}&per_page=10`, { searchValue });
            const responseData = response.data;

            if (responseData) {
                setReviews(responseData.data);
                setCurrentPage(responseData.current_page);
                setTotalPages(responseData.last_page);
            }
            setLoding(false);
        } catch (error) {
            toast.error(error.response.data.message);
            setLoding(false);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            getReview(currentPage + 1);
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            getReview(currentPage - 1);
        }
    };


    const handelEditModal = (item) => {
        setReviewToUpdate(item)
        setReviewModal(true)
    }

    function formatDate(dateString) {
        const date = new Date(dateString);
        return date.toLocaleString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        });
    }


    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
            className="flex flex-col w-full h-full px-6 py-5 bg-neutral-50/80"
        >
            {loading && <Loading />}

            {/* Header */}
            <div className="flex lg:justify-between gap-3 lg:items-center flex-col lg:flex-row mb-6">
                <div className="flex flex-col items-start gap-1">

                    <h1 className="text-xl font-semibold text-neutral-900 dark:text-white">Reviews</h1>
                    <p className="text-sm text-neutral-600 ">Manage reviews here .</p>

                </div>
                <div className="flex flex-col lg:flex-row lg:items-center gap-3">
                    {/* Search */}
                    <div className="relative">
                        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-neutral-400" />
                        <input
                            onChange={(e) => setSearchValue(e.target.value)} value={searchValue}
                            type="text"
                            placeholder="Search reviews..."
                            className="pl-10 pr-4 py-2 lg:w-64 w-full text-sm border border-neutral-200 dark:border-neutral-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-neutral-800 dark:text-white"
                        />
                    </div>


                    {/* New User Button */}
                    {checkAccess("reviews", "create") && (
                        <button
                            onClick={() => { setReviewModal(true) }} className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-[#2B2B35] rounded-lg hover:bg-cyan-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        >
                            <CirclePlus className="w-4 h-4 mr-2" />
                            New Review
                        </button>
                    )}
                </div>
            </div>
            <section className=" w-full mx-auto">


                <div className="flex flex-col mt-4">
                    <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                            <div className="overflow-hidden border border-neutral-200 dark:border-neutral-700 md:rounded-lg">
                                <table className="min-w-full divide-y divide-neutral-200 dark:divide-neutral-700">
                                    <thead className="bg-neutral-50 h-14 dark:bg-neutral-800">
                                        <tr>
                                            <th
                                                scope="col"
                                                className="px-6 py-3.5 text-sm whitespace-nowrap font-normal text-left rtl:text-right text-neutral-500 dark:text-neutral-400"
                                            >
                                                Client / System
                                            </th>
                                            <th
                                                scope="col"
                                                className="px-12 py-3.5 text-sm font-normal text-left rtl:text-right text-neutral-500 dark:text-neutral-400"
                                            >
                                                Product
                                            </th>
                                            <th
                                                scope="col"
                                                className="px-12 py-3.5 text-sm font-normal text-left rtl:text-right text-neutral-500 dark:text-neutral-400"
                                            >
                                                Rating
                                            </th>
                                            <th
                                                scope="col"
                                                className="px-12 py-3.5 text-sm font-normal text-left rtl:text-right text-neutral-500 dark:text-neutral-400"
                                            >
                                                Comment
                                            </th>
                                            <th
                                                scope="col"
                                                className="px-8 py-3.5 text-sm font-normal text-left rtl:text-right text-neutral-500 dark:text-neutral-400"
                                            >
                                                Date
                                            </th>
                                            <th
                                                scope="col"
                                                className="px-8 py-3.5 text-sm font-normal text-left rtl:text-right text-neutral-500 dark:text-neutral-400"
                                            >
                                                Actions
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-neutral-200 dark:divide-neutral-700 dark:bg-neutral-900">
                                        {reviews.map((review) => (
                                            <React.Fragment key={review.id}>
                                                <tr className='h-16'>
                                                    <td className="px-6  text-sm text-start font-medium whitespace-nowrap">
                                                        <div className="flex items-center">


                                                            <div className="ml-4 text-start">
                                                                <div className="text-sm font-medium text-neutral-900">{review.user?.fullName}</div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="px-12  text-sm text-start font-medium whitespace-nowrap">
                                                        <div className="flex items-center">
                                                            {review.product ?
                                                                <img
                                                                    src={review.product?.images[0] || "/placeholder.svg"}
                                                                    alt={review.product.name}
                                                                    className="h-10 w-10 rounded-lg object-cover"
                                                                />
                                                                :
                                                                <div />
                                                            }

                                                            <div className="ml-4 text-start">
                                                                <div className="text-sm font-medium text-neutral-900">{review.product?.name}</div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="px-12  text-sm text-start font-medium whitespace-nowrap">
                                                        <div>
                                                            <p className="text-sm font-normal text-neutral-600 dark:text-neutral-400">
                                                                {review.rating}
                                                            </p>
                                                        </div>
                                                    </td>
                                                    <td className="px-12  text-sm text-start font-medium whitespace-nowrap">
                                                        <div>
                                                            <p className="text-sm truncate max-w-[200px] line-clamp-1 font-normal text-neutral-600 dark:text-neutral-400">
                                                                {review.comment}
                                                            </p>
                                                        </div>
                                                    </td>
                                                    <td className="px-8  text-start text-sm whitespace-nowrap">
                                                        <div>
                                                            <p className="text-neutral-500 dark:text-neutral-400">
                                                                {formatDate(review.created_at)}
                                                            </p>
                                                        </div>
                                                    </td>
                                                    <td className="px-8  text-sm whitespace-nowrap">
                                                        <div className="flex justify-start items-center gap-3">
                                                            {checkAccess("reviews", "delete") && (
                                                                <button
                                                                    onClick={() => {
                                                                        setReviewId(review.id)
                                                                        setDeleteModal(true)
                                                                    }}
                                                                    className="flex justify-center hover:scale-110 transition-all duration-400 items-center  dark:bg-red-600 dark:bg-opacity-10 rounded-md hover:bg-neutral-200 text-neutral-500"
                                                                >
                                                                    <Trash2 size={16} />

                                                                </button>
                                                            )}
                                                            {checkAccess("reviews", "update") && (
                                                                <button
                                                                    onClick={() => handelEditModal(review)}
                                                                    className="flex justify-center hover:scale-110 transition-all duration-400 items-center  dark:bg-green-600 dark:bg-opacity-10 rounded-md hover:bg-neutral-200 text-neutral-500"
                                                                >
                                                                    <Pencil size={16} />

                                                                </button>
                                                            )}

                                                        </div>
                                                    </td>
                                                </tr>

                                            </React.Fragment>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="mt-6 sm:flex sm:items-center sm:justify-between ">
                    <div className="text-sm text-neutral-500 dark:text-neutral-400">
                        Page <span className="font-medium text-neutral-700 dark:text-neutral-100">{currentPage} of {totalPages}</span>
                    </div>
                    <div className="flex items-center mt-4 gap-x-4 sm:mt-0">
                        <button
                            onClick={handlePrevious}
                            disabled={currentPage === 1}
                            className="flex items-center justify-center w-1/2 px-5 py-2 text-sm text-neutral-700 capitalize transition-colors duration-200 bg-white border rounded-md sm:w-auto gap-x-2 hover:bg-neutral-100 dark:bg-neutral-900 dark:text-neutral-200 dark:border-neutral-700 dark:hover:bg-neutral-800"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 rtl:-scale-x-100">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18" />
                            </svg>
                            <span>Previous</span>
                        </button>
                        <button
                            onClick={handleNext}
                            disabled={currentPage === totalPages}
                            className="flex items-center justify-center w-1/2 px-5 py-2 text-sm text-neutral-700 capitalize transition-colors duration-200 bg-white border rounded-md sm:w-auto gap-x-2 hover:bg-neutral-100 dark:bg-neutral-900 dark:text-neutral-200 dark:border-neutral-700 dark:hover:bg-neutral-800"
                        >
                            <span>Next</span>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 rtl:-scale-x-100">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3" />
                            </svg>
                        </button>
                    </div>
                </div>

            </section>



            <ReviewModal
                isOpen={reviewModal}
                onClose={() => { setReviewModal(false) }}
                reviews={reviews}
                ReviewToUpdate={reviewToUpdate}
                setDone={setDone}
                done={done}
                setReviewToUpdate={setReviewToUpdate}
            />


            <DeleteModal setDeleteId={setReviewId} open={deleteModal} setOpen={setDeleteModal} DeleteId={ReviewId} Model='reviews' setDone={setDone} setLoding={setLoding} done={done} />

        </motion.div >


    )
}

export default Reviews